<template>
  <div class="has-text-centered wrapper" id="why-are-we-doing-this">

    <div class="whyAreWeDoingThis is-flex is-flex-direction-column is-justify-content-space-between">
      <div class="inner-content">
        <h2>
          {{ $t('page.whatIsLiffery.new2023.OWhyAreWhyDoingThis.title1') }}
        </h2>
        <p class="mt-4">
          {{ $t('page.whatIsLiffery.new2023.OWhyAreWhyDoingThis.text1') }}
        </p>
        <img
            class="image-svg"
            src="@/assets/landing-pages/forPeople/2023/ads-target-you.svg" alt="Liffery fan">
        <img
            class="image-svg-mobile"
            src="@/assets/landing-pages/forPeople/2023/ads-target-you-mobile.svg" alt="Liffery fan">
      </div>

    </div>

    <div class="weHopeToChangeItAll">
      <div class="inner-content">
        <h2>
          {{ $t('page.whatIsLiffery.new2023.OWhyAreWhyDoingThis.title2') }}
        </h2>
        <p class="mt-4 mb-4">
          {{ $t('page.whatIsLiffery.new2023.OWhyAreWhyDoingThis.text2a') }}<br/>
          {{ $t('page.whatIsLiffery.new2023.OWhyAreWhyDoingThis.text2b') }}
        </p>
        <img
            class="image-svg"
            src="@/assets/landing-pages/forPeople/2023/you-target-ads.svg" alt="Liffery fan">
        <img
            class="image-svg-mobile"
            src="@/assets/landing-pages/forPeople/2023/you-target-ads-mobile.svg" alt="Liffery fan">
      </div>
    </div>

  </div>
</template>

<style scoped lang="scss">

.wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.image-svg {
  display: block;
  text-align: center;

  &-mobile {
    display: none;
  }

  @media screen and (max-width: $tablet) {
    display: none;
    &-mobile {
      display: block;
    }
  }
}


.whyAreWeDoingThis,
.weHopeToChangeItAll {
  padding: 6rem;

  @media screen and (max-width: $tablet) {
    text-align: center;
    padding: 2rem;
    padding-top: 4rem;
  }

  .inner-content {
    max-width: 1220px;
    margin: auto;

    img {
      margin-top: 1.5rem;
      margin-bottom: 2rem;
      margin-left: auto;
      margin-right: auto;
    }
  }
}

.whyAreWeDoingThis {
  padding-top: 4rem;
  padding-bottom: 0;
}

.weHopeToChangeItAll {
  background-color: #8ED2DB;
  margin-top: -44px;
  padding-bottom: 2rem;
}
</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import OArrowDownScroll from '@/components/organisms/landing/sections/OArrowDownScroll.vue';

@Component({
  components: { OArrowDownScroll }
})
export default class OWhyAreWhyDoingThis extends Vue {
}
</script>
